import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      await fetch('/api/auth/forgot', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
    } catch { /* ignore */ }
    setSent(true);
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{ background: '#0f172a' }}>
      <div className="w-full max-w-md bg-white rounded-2xl shadow-xl p-8">
        <h1 className="text-xl font-bold text-slate-900 mb-2">Restablecer contraseña</h1>
        {sent ? (
          <>
            <p className="text-sm text-slate-600 mb-6">
              Si existe una cuenta con ese email, te hemos enviado un enlace para restablecer tu
              contraseña. Revisa tu bandeja de entrada (caduca en 1 hora).
            </p>
            <Link to="/login" className="text-sm text-teal-600 hover:text-teal-700 font-medium">← Volver a iniciar sesión</Link>
          </>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <p className="text-sm text-slate-600">Introduce tu email de administrador y te enviaremos un enlace para restablecer la contraseña.</p>
            <input
              type="email" required value={email} onChange={e => setEmail(e.target.value)}
              placeholder="tu@kanarix.es"
              className="w-full px-4 py-2.5 border border-slate-300 rounded-lg focus:ring-2 focus:ring-teal-500 text-sm"
            />
            <button type="submit" disabled={loading}
              className="w-full py-2.5 bg-teal-700 hover:bg-teal-800 disabled:bg-teal-400 text-white rounded-lg font-medium text-sm transition-colors">
              {loading ? 'Enviando...' : 'Enviar enlace'}
            </button>
            <div className="text-center">
              <Link to="/login" className="text-xs text-slate-500 hover:text-slate-700">← Volver</Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
